// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__21-9Q","icon":"styles_icon__1w84u"};